export default "__VITE_ASSET__B8LmCGG6__"